import { FlowSteps } from '@llura/constants';

import { useStrings } from '../../../hooks/useStrings';
import { useStepTiming } from '../../../lib/analytics';
import { IntroScreen } from '../intro-screen';
import { IntroMark } from '../intro-mark';

interface IntroPhilosophyProps {
  onBack: () => void;
  onNext: () => void;
  onLogin: () => void;
}

export function IntroPhilosophy({ onBack, onNext, onLogin }: IntroPhilosophyProps) {
  useStepTiming(FlowSteps.IntroScreen3);
  const { strings } = useStrings();
  return (
    <IntroScreen
      step={3}
      tag={strings.intro.screen3.tag}
      title={strings.intro.screen3.title}
      italic={strings.intro.screen3.italic}
      body={strings.intro.screen3.body}
      visual={<IntroMark variant="swirl" />}
      onBack={onBack}
      onNext={onNext}
      onLogin={onLogin}
    />
  );
}
